import { LoaderActions } from '@store/loaders'
import { call, put } from 'redux-saga/effects'

import { type ApiUsage, ApiUsageService } from '@/services/apiUsage'
import { InternalApiUsageActions } from '../actions'

export function* fetchApiUsage() {
  yield put(LoaderActions.set('api_usage_fetch'))
  yield put(InternalApiUsageActions.setError(false))

  try {
    const usage: ApiUsage = yield call(ApiUsageService.get)

    yield put(InternalApiUsageActions.set(usage))
  } catch (error) {
    console.error('Failed to load API usage', error)

    yield put(InternalApiUsageActions.setError(true))
  } finally {
    yield put(LoaderActions.unset('api_usage_fetch'))
  }
}
